export default {
  text: {
    en: 'Retail price: {price}',
  },
}
